import * as React from 'react';
import { Field } from 'react-final-form';

interface IFormCheckboxProps {
    name: string;
    label: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    wrapped?: boolean;
    isDisabled?: boolean;
    style?: React.CSSProperties;
}

// TODO: Change to stateless component;
export default class FormCheckbox extends React.Component<IFormCheckboxProps> {
    style = {
        ...this.props.style,
        display: 'inline-block',
    };

    render() {
        const field = (
            <Field name={this.props.name} type="checkbox">
                {({ input }) => (
                    <div style={this.style}>
                        <input
                            className={`dlc-form-checkbox ${this.props.wrapped ? '' : this.props.className}`}
                            id={`dlc-ch-${this.props.name}`}
                            type="checkbox"
                            {...input}
                            onChange={(e) => {
                                input.onChange(e);
                                if (this.props.onChange) {
                                    this.props.onChange(e);
                                }
                            }}
                            disabled={this.props.isDisabled || false}
                        />
                        <label
                            className={this.props.wrapped ? `dlc-form-checkbox-wrapped-label` : `${this.props.className}`}
                            htmlFor={`dlc-ch-${this.props.name}`}
                        >
                            {this.props.label}
                        </label>
                    </div>
                )}
            </Field>
        );

        if (this.props.wrapped) {
            return (
                <div style={this.props.style} className={`${this.props.className} dlc-form-checkbox-wrapped`}>
                    <div className="dlc-form-checkbox-wrapped-inner">{field}</div>
                </div>
            );
        } else {
            return <div style={{ margin: '.5rem 0 1rem 0' }}>{field}</div>;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/forms/redesign/FormCheckbox.tsx